/** @format */

const template = `
<div class="row header">
  <div ng-class="{'col-4': $ctrl.showMenuButton(), 'col-6': !$ctrl.showMenuButton()}">
    <button
      type="button"
      ng-click="$ctrl.sortBy('name')"
      class="non-button"
      aria-sort="{{$ctrl.getAriaSortValue('name')}}"
      aria-label="{{'PROFILE.ATTAINMENT.NAME_AND_CODE' | translate}}">
      {{'PROFILE.ATTAINMENT.NAME_AND_CODE' | translate}}
      <sis-sort-by-indicator
        [column]="'name'"
        [current]="$ctrl.currentSort"
        [order]="$ctrl.sortableFields.name.order"></sis-sort-by-indicator>
    </button>
  </div>
  <div class="col-2 credit">
    <button
      type="button"
      ng-click="$ctrl.sortBy('credits')"
      class="non-button"
      aria-sort="{{$ctrl.getAriaSortValue('credits')}}"
      aria-label="{{'PROFILE.ATTAINMENT.CREDITS' | translate}} {{$ctrl.getSorterAriaLabel('credits')}}">
      {{'PROFILE.ATTAINMENT.CREDITS' | translate}}
      <sis-sort-by-indicator
        [column]="'credits'"
        [current]="$ctrl.currentSort"
        [order]="$ctrl.sortableFields.credits.order"></sis-sort-by-indicator>
    </button>
  </div>
  <div class="col-2 grade">
    <button
      type="button"
      ng-click="$ctrl.sortBy('grade.numericCorrespondence')"
      class="non-button"
      aria-sort="{{$ctrl.getAriaSortValue('grade.numericCorrespondence')}}"
      aria-label="{{'PROFILE.ATTAINMENT.GRADE' | translate}} {{$ctrl.getSorterAriaLabel('grade.numericCorrespondence')}}">
      {{'PROFILE.ATTAINMENT.GRADE' | translate}}
      <sis-sort-by-indicator
        [column]="'grade.numericCorrespondence'"
        [current]="$ctrl.currentSort"
        [order]="$ctrl.sortableFields['grade.numericCorrespondence'].order"></sis-sort-by-indicator>
    </button>
  </div>
  <div class="col-2 date">
    <button
      type="button"
      ng-click="$ctrl.sortBy('attainmentDate')"
      class="non-button"
      aria-sort="{{$ctrl.getAriaSortValue('attainmentDate')}}"
      aria-label="{{'PROFILE.ATTAINMENT.DATE' | translate}} {{$ctrl.getSorterAriaLabel('attainmentDate')}}">
      {{'PROFILE.ATTAINMENT.DATE' | translate}}
      <sis-sort-by-indicator
        [column]="'attainmentDate'"
        [current]="$ctrl.currentSort"
        [order]="$ctrl.sortableFields.attainmentDate.order"></sis-sort-by-indicator>
    </button>
  </div>
  <div ng-if="$ctrl.showMenuButton" class="col-2"></div>
</div>
<div ng-if="$ctrl.tree.length === 0" class="row">
  <span class="col-12 empty" translate>PROFILE.ATTAINMENT.EMPTY</span>
</div>
`;
export default template;
